import { EmptyValue } from '@/components/common/EmptyValue';
import { isWorkTypeCode, WORK_TYPE_TONE } from '@/constants/workTypes';
import { cn } from '@/lib/utils';
import { CODE_BADGE_CLASS } from '@/styles/codeBadge';
import { STATUS_COLOR_CLASS } from '@/styles/statusColors';

interface WorkTypeBadgeProps {
  code: string | null;
  name?: string | null | undefined;
}

export function WorkTypeBadge({ code, name }: WorkTypeBadgeProps) {
  if (!code) return <EmptyValue />;
  const tone = isWorkTypeCode(code) ? WORK_TYPE_TONE[code] : 'neutral';

  return (
    <span title={name ?? undefined} className={cn(CODE_BADGE_CLASS, STATUS_COLOR_CLASS[tone])}>
      {code}
    </span>
  );
}
